import script from "./ChecklistViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistViewPage.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistViewPage.vue?vue&type=style&index=0&id=1a016148&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a016148"]])

export default __exports__